import { createContext } from 'react';
import type { IIdleTimer } from 'react-idle-timer';

export interface AuthContextType {
  hasToken?: boolean;
  setHasToken?: (hasToken: boolean) => void;
  setTokenExpiration?: (minutes: number) => void;
  refreshTokenTimer?: IIdleTimer;
  validLicense?: boolean;
  refetchLicense?: () => void;
}

const AuthContext = createContext<AuthContextType>({});

export default AuthContext;
